import { Icon } from "../../icons";
import { isAction, type MenuAction, type MenuEntry } from "./menuEntry";

function MenuActionItem({ action, onClose }: { action: MenuAction; onClose: () => void }): React.JSX.Element {
  return (
    <button
      type="button"
      role="menuitem"
      className={`nb-menu-item${action.tone === "danger" ? " is-danger" : ""}${action.selected ? " is-selected" : ""}`}
      disabled={action.disabled}
      onClick={() => {
        onClose();
        action.onSelect();
      }}
    >
      {action.icon ? <Icon name={action.icon} /> : null}
      <span className="nb-truncate">{action.label}</span>
      {action.hint ? <span className="nb-menu-item-trail">{action.hint}</span> : null}
      {action.selected !== undefined ? <Icon name="check" className="nb-menu-check" /> : null}
    </button>
  );
}

/** One menu entry: a separator, an action (which closes the menu before running), a heading or custom content. */
export function DropdownMenuEntry({ entry, onClose }: { entry: MenuEntry; onClose: () => void }): React.JSX.Element {
  if (entry === "separator") return <hr className="nb-menu-sep" />;
  if (isAction(entry)) return <MenuActionItem action={entry} onClose={onClose} />;
  if ("heading" in entry) return <div className="nb-menu-label">{entry.heading}</div>;
  return <div>{entry.node}</div>;
}
